<template>
  <div class="tag-wrap">
    <div
      class="tag"
      v-for="item in list"
      :key="item.ID"
      @click="chooseTag(item.ID)"
      :class="{ active: activeId == item.ID }"
    >
      #{{ item.CONTENT }}
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  list: {
    default: [],
  },
  activeId: {
    default: "",
  },
});
const emits = defineEmits(["chooseTag"]);
const chooseTag = (id) => {
  emits("chooseTag", id);
};
</script>

<style scoped lang="scss">
@import "@assets/scss/dimen.scss";
@import "@assets/scss/mixin.scss";
.tag-wrap {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin: 0 auto 30px;
  .tag {
    background: $layercolor;
    border-radius: 14px;
    text-align: center;
    line-height: 70px;
    height: 70px;
    margin-right: 20px;
    padding: 0 20px;
    box-sizing: border-box;
    font-size: $fzNormal;
    cursor: pointer;
    @include addTouchEffect();
    &.active {
      color: $maincolor;
    }
  }
}

@media only screen and (min-height: 640px) and (orientation: landscape) {
  .tag-wrap {
    margin: 0 auto calc(30px / $pcRate);
    .tag {
      border-radius: calc(14px / $pcRate);
      line-height: calc(70px / $pcRate);
      height: calc(70px / $pcRate);
      margin-right: calc(20px / $pcRate);
      padding: 0 calc(20px / $pcRate);
      font-size: $fzNormalPc;
    }
  }
}
</style>
